const yearsList = () => {
	let currentYear = "2022";
	let count = new Date().getFullYear() + 23;
	let yearList = [];
	Array.from({ length: count }, (v, k) => k).map((k) => {
		if (k >= currentYear) {
			return yearList.push({
				value: `${k}`,
				label: `${k}`,
			});
		}
	});
	return yearList;
};

export const years = yearsList();
